
/* Volume wrapper */

.spotify-player-volume-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--button-background);
  border-radius: 0.4em;
  padding-left: 0.4em;
  padding-right: 0.4em;
  max-width: 500px;
  flex: 1;
}

.spotify-player-volume-control span{
  width: 32px;
  height: 32px;
  font-size: 1.5rem;
  color: var(--darkest);
  justify-content: center;
  align-items: center;
  display: flex;
}

/* Volume styling */

.spotify-player-volume-slider {
  -webkit-appearance: none;
  flex: 4;
  height: 8px;
  border-radius: 0.4em;
  transition: background 0.3s ease;
}

.spotify-player-volume-slider::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0.4em;
  background: var(--lighter);
  height: 18px;
}

.spotify-player-volume-slider:disabled::-webkit-slider-runnable-track {
  background: var(--dark);
}

.spotify-player-volume-slider::-webkit-slider-runnable-track:hover {
  background: var(--lightest);
  cursor: pointer;
}

.spotify-player-volume-slider::-webkit-slider-runnable-track:hover {
  background: var(--lightest);
  cursor: pointer;
}

.spotify-player-volume-slider:disabled::-webkit-slider-runnable-track:hover {
  transform: none;
  cursor: not-allowed;
  background: var(--dark);
}

.spotify-player-volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 24px;
  border-radius: 0.4em;
  background: var(--dark);
  position: relative;
  top: -3px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.spotify-player-volume-slider:disabled::-webkit-slider-thumb {
  background: var(--darker);
}

.spotify-player-volume-slider::-webkit-slider-thumb:hover {
  background: var(--blue);
  transform: scale(1.2);
}

.spotify-player-volume-slider:disabled::-webkit-slider-thumb:hover {
  transform: none;
  cursor: not-allowed;
  background: var(--darker);
}
